import React from "react";

export default function HotkeyTooltipText({ text }) {
	return <span className="rt-hotkey-text">Hotkeys - {text}</span>;
}
